import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import '../Dashboard/Dashboard.css'
import './invoice.css'
import CustomTable from '@/product/components/molecules/CustomTable'
import ReturnContext from '@/product/context/return/returnContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceView from './view'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import RefundInvoice from '@/custom/components/organisms/RefundInvoice'
import { mapData } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'

const Invoice = (props) => {
    const returnContext = useContext(ReturnContext)

    const {
        all_invoices,
        getAllInvoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = returnContext

    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()

    const authContext = useContext(AuthContext)
    const { user } = authContext

    const [changeStatus, setChangeStatus] = React.useState(false)

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        sid: 0,
    })

    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenPopup = (popup, status, id, sid) => {
        if (popup) {
            setManage({ popup, status, id, sid })
        } else {
            setManage({ popup, status: 'new', id: 0, sid: 0 })
        }
    }

    const changeChangeStatus = () => {
        formikSelection.resetForm()
        setChangeStatus(!changeStatus)
    }

    let action = props.match.params.action

    const [tableBody, setTableBody] = useState([])

    const tableBodyRef = useRef(tableBody)
    useEffect(() => {
        tableBodyRef.current = tableBody
    })

    const formik = useFormik({
        initialValues: {
            // action: action,
            filters: {
                action: {
                    field: 'b.paid',
                    type: 'in',
                    value: '',
                },
                custom_projects_lot_no: {
                    value: '',
                    type: 'like',
                    field: 'cp.lot_no',
                },
                projects_title: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                auctionlot_title: {
                    value: '',
                    type: 'like',
                    field: 'ac.title',
                },
                searchterm: {
                    value: '',
                    type: 'in',
                    field: 'b.invoice_id',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'b.returned_date',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'b.returned_date',
                },
            },
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllInvoices(values)
        },
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            invoice_notes: '',
        },
        onSubmit: (values) => {
            if (
                values.action === 'paid' ||
                values.action === 'unpaid' ||
                values.action === 'cancel_return_request'
            ) {
                changeProductStatus(values)
            }
        },
    })

    useEffect(() => {
        if (all_invoices) {
            setTableBody(
                all_invoices.records.length ? all_invoices.records : []
            )
            setIsLoading(false)
        }
    }, [all_invoices])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        if (action === 'requested' || action === 'cancelled') {
            formik.values.action = action
        } else {
            formik.values.action = ''
        }
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        getAllInvoices(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        console.log('formikSelection.values', formikSelection.values)
    }, [formikSelection.values])

    const onClickEdit = (id, secondaryID, type) => {
        console.log('i am onClickEdit', id, secondaryID, type)
        const product = tableBodyRef.current?.filter(
            (item) => item?.id === id && item?.user_id === secondaryID
        )[0]
        console.log('i am onClickEdit 2', product)
        if (product?.partial_return_invoice) {
            handleRedirectInternal(
                history,
                `invoice/view/${product?.invoice_id}/${secondaryID}`
            )
        } else if (product?.common_invoice) {
            handleRedirectInternal(
                history,
                `invoice/view/${product?.common_invoice}/${secondaryID}`
            )
        } else {
            handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
        }
    }
    const onClickUserEdit = (id, secondaryID, type) => {
        if (
            type === 'edit' &&
            (user?.emp_type === 'super_admin' || user?.emp_type === 'admin')
        ) {
            handleRedirectInternal(history, `user/edit/${secondaryID}`)
        }
    }
    const onClickView = (id, sid, type) => {
        console.log('sid', sid)
        console.log('typpeee', type)
        handleRedirectInternal(history, `return/view/${id}/${sid}`)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        if (
            action === 'paid' ||
            action === 'unpaid' ||
            action === 'cancel_return_request'
        ) {
            setChangeStatus(true)
        }
    }

    const toggleRefundPopup = (popup, status, data) => {
        if (status === 'refresh') {
            getAllInvoices(formik.values)
        }
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({
                popup,
                status: status ? status : 'new',
                data: null,
            })
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            // {
            //     buttonType: 'visibility',
            //     clickType: 'view',
            //     onclick: onClickView,
            //     tooltipTitle: 'View invoice',
            // },
        ]
        if (action === 'requested') {
            actionPush.push({
                buttonType: 'undo',
                clickType: 'edit',
                onclick: onClickRefundInvoice,
                tooltipTitle: 'Refund Invoice',
                clickID: 'project_id',
                secondaryClickID: 'user_id',
            })
        }
        return actionPush
    }

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id: tableBodyRef.current?.filter(
                (item) =>
                    item?.project_id === id && item?.user_id === secondaryID
            )[0]?.common_invoice,
            user_id: secondaryID,
            singleItem: true,
            project_id: tableBodyRef.current
                ?.filter((item) => item?.project_id === id)
                ?.map((item) => item?.project_id),
        })
    }

    const tableValues = []

    if (!['requested', 'cancelled'].includes(action)) {
        tableValues.push(
            {
                field: 'return_invoice',
                type: 'hyperlink',
                firstChild: true,
                sort: false,
                disablePadding: false,
                click: true,
                onclick: onClickView,
                clickID: 'return_invoice',
                secondaryClickID: 'user_id',
                clickType: 'view',
                label: 'Return ID',
                filterable: true,
                filterField: 'b.return_invoice',
            },
            {
                field: 'returned_date',
                type: 'date',
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: 'Returned Date',
                filterable: true,
                filterField: 'b.returned_date',
            }
        )
    }

    tableValues.push(
        {
            field: 'projects_id',
            type: 'text',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Lot ID',
            // click: true,
            // onclick: onClickEdit,
            clickID: 'projects_id',
            secondaryClickID: 'user_id',
            filterable: true,
            filterField: 'b.project_id',
        },
        {
            field: 'projects_title',
            type: 'text',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Lot Title',
            // click: true,
            // onclick: onClickEdit,
            clickID: 'projects_title',
            secondaryClickID: 'user_id',
            filterable: true,
            filterField: 'p.title',
        },
        // {
        //     field: 'invoice_id',
        //     type: 'or_fields',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Invoice ID',
        //     click: true,
        //     onclick: onClickEdit,
        //     clickID: 'id',
        //     secondaryClickID: 'user_id',
        //     filterable: true,
        //     filterField: 'b.invoice_id',
        //     custom: 'common_invoice',
        // },
        {
            field: 'total_items',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Items',
        },
        {
            field: 'users_first_name,users_last_name',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Username',
            filterable: true,
            filterField: 'u.first_name,u.last_name',
        },
        {
            field: 'users_email',
            type: 'hyperlink',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'User Email',
            filterable: true,
            filterField: 'u.email',
            click: true,
            onclick: onClickUserEdit,
            clickID: 'id',
            secondaryClickID: 'user_id',
            clickType: 'edit',
        }
        // {
        //     field: 'action',
        //     type: 'button',
        //     clickID: 'return_invoice',
        //     secondaryClickID: 'user_id',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Action',
        //     isMultiple: getMultipleAction(),
        // },
    )

    if (action === 'requested') {
        tableValues.push({
            field: 'action',
            type: 'button',
            clickID: 'project_id',
            secondaryClickID: 'user_id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        })
    }

    const tableActions = []

    if (action === 'requested') {
        tableActions.push({
            label: 'Cancel Return Request',
            icon: <span className="material-icons">low_priority</span>,
            onclick: onSelectMultiProducts,
            type: 'cancel_return_request',
        })
    }

    // if (action === 'completed') {
    //     tableActions.push({
    //         label: 'Move to Pending',
    //         icon: <span className="material-icons">low_priority</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'unpaid',
    //     })
    // } else if (action === 'pending') {
    //     tableActions.push({
    //         label: 'Move to Completed',
    //         icon: <span className="material-icons">low_priority</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'paid',
    //     })
    // } else {
    //     tableActions.push(
    //         {
    //             label: 'Move to Pending',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'unpaid',
    //         },
    //         {
    //             label: 'Move to Completed',
    //             icon: <span className="material-icons">low_priority</span>,
    //             onclick: onSelectMultiProducts,
    //             type: 'paid',
    //         },
    //     )
    // }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Created From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Created To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
        ],
    }

    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        // formik.values.filters.searchterm.value = ''
        getAllInvoices(formik.values)
    }

    useEffect(() => {
        console.log('i am responseStatusInvoice', responseStatusInvoice)
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                changeChangeStatus()
                getAllInvoices(formik.values)
            }
        }
    }, [responseStatusInvoice])

    const cancelReturnNotes = [
        {
            label: 'Cancellation Reason',
            name: 'invoice_notes',
            type: 'textarea',
            placeholder: 'Enter reason for cancellation',
            formik: formikSelection,
        },
    ]

    return (
        <Layout>
            {' '}
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_invoices}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllInvoices}
                />
            </div>
            <RefundInvoice data={manageRefund} function={toggleRefundPopup} />
            <CustomDialog
                title={
                    action === 'requested'
                        ? 'Cancel Return Request'
                        : 'Change product status'
                }
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {action === 'requested'
                        ? 'Are you sure you want to cancel the return request ?'
                        : 'Are you sure you want to change the status ?'}
                </h5>
                {action === 'requested' ? mapData(cancelReturnNotes) : null}
                <div className="actionWrapper">
                    <Button
                        id="return_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="invoice_submit"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default Invoice
